import React from "react";
import { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import { loaderMsg, loadertype } from "../../constants";
import Loader from "react-loaders";
import { getPaymntGistory } from "../../util/APIUtils";
import CategoryBody from "./CategoryBody";

export default function Category() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    getPaymntGistory(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  return (
    <BlockUi
      tag="div"
      blocking={block}
      loader={<Loader active type={loadertype} color="#8dc63f" />}
      message={loaderMsg}
    >
      <div className="animated fadeIn">
        <CategoryBody data={trans} />
      </div>
    </BlockUi>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Category.js